import { RuleTableHandlers, TableConfig } from "../../../../../shared/ui/custom-table/model/table-config.model";
import { FINANCING_LONG_TERM } from "../../../financing-detail/financing-detail.model";
import { consts } from "../../../../../consts";

export function createPrivateFinancingTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string, defaultFilter?: any } = {}
): TableConfig {
  const {
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    selectable = false,
    summaryTemplate,
    rowConfig = {},
    headerActions,
    gridActions,
    columns,
  } = handlers;

  const handleAction = (row: any, action: TableRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  return {
    columns: columns,
    actions: [
      { label: 'Editar', icon: 'edit', callback: (row) => handleAction(row, TableRowAction.Edit) },
      { label: 'Pagar cuotas', icon: 'payment', callback: (row) => handleAction(row, TableRowAction.PayInstallments) },
      { label: 'Constitución', icon: 'account_balance', callback: (row) => handleAction(row, TableRowAction.Constitution) },
      { label: 'Deuda a corto plazo', icon: 'swap_vert', visible: (row) => !!row && row.duracion === FINANCING_LONG_TERM, callback: (row) => handleAction(row, TableRowAction.ShortTermDebt) },
      { label: 'Importar cuadro de amortización', icon: 'file_upload', callback: (row) => handleAction(row, TableRowAction.UploadFile) },
      { label: 'Descargar cuadro de amortización', icon: 'file_download', visible: (row) => !!row && !!row.filesFinanciacionPrivadaUid && row.filesFinanciacionPrivadaUid !== consts.EMPTY_GUID, callback: (row) => handleAction(row, TableRowAction.DownloadFile) },
      { label: 'Eliminar', icon: 'delete', callback: (row) => handleAction(row, TableRowAction.Delete) },
    ],
    gridActions: gridActions,
    headerActions: headerActions,
    filterView: options.filterView || '',
    defaultFilter: options.defaultFilter || {},
    rowConfig: {
      ...rowConfig,
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand,
    },
    selectable: selectable,
    pagination: true,
    summaryTemplate: summaryTemplate,
  };
}

export enum TableRowAction {
  Edit = 'edit',
  Delete = 'delete',
  UploadFile = 'uploadFile',
  DownloadFile = 'downloadFile',
  Constitution = 'constitution',
  ShortTermDebt = 'shortTermDebt',
  PayInstallments = 'payInstallments',
}
